import React from 'react';
const benefits = [{
  emoji: '⚡',
  title: 'Gagnez des heures de préparation chaque semaine',
  description: 'Ne perdez plus votre temps à chercher des exercices ou construire chaque séance depuis zéro. Ouvrez simplement le système, choisissez les ressources adaptées et commencez votre consultation.'
}, {
  emoji: '👨‍⚕️',
  title: 'Travaillez avec plus de confiance',
  description: 'Structurez facilement vos consultations grâce à des progressions claires, des outils professionnels et une méthode prête à l’emploi. Consacrez plus de temps à vos patients et moins à la préparation.'
}, {
  emoji: '📈',
  title: 'Optimisez vos prises en charge',
  description: 'Utilisez des exercices, des progressions et des protocoles déjà organisés pour proposer des traitements plus structurés, cohérents et faciles à adapter à chaque patient.'
}, {
  emoji: '😊',
  title: 'Organisez votre pratique comme un professionnel',
  description: 'Toutes vos ressources sont réunies dans un seul système. Moins de recherches. Moins d’improvisation. Plus d’organisation.'
}];
export function BenefitsSection() {
  return <section className="border-t-4 border-brand-ivory bg-white px-4 py-5 sm:px-6" data-id="element-16" data-mp="27e3x8dlzbg1w">
      <h2 className="mb-3 text-center text-3xl font-black uppercase leading-none" data-id="element-17" data-mp="2l4pi27uzu02f">CE QUI VA CHANGER POUR VOUS</h2>
      <div className="flex flex-col gap-2" data-id="element-18" data-mp="2g5dzquezamiq">
        {benefits.map(benefit => <article key={benefit.title} className="flex gap-2.5 rounded-r-md border-l-4 border-brand-gold bg-brand-ivory p-3 shadow-sm" data-id="element-19" data-mp="1sg1rbwrh6ihh">
            <div className="mt-0.5 shrink-0 text-xl leading-none" data-id="element-20" data-mp="1ofrjeek4hhzz">{benefit.emoji}</div>
            <div data-id="element-21" data-mp="22er8tofgm0x7">
              <h3 className="mb-1 font-body text-sm font-extrabold uppercase leading-tight text-brand-navy sm:text-base" data-id="element-22" data-mp="22fah0dfb5ay1">{benefit.title}</h3>
              <p className="text-sm font-medium leading-snug" data-id="element-23" data-mp="1xhr0t7z1uo3g">{benefit.description}</p>
            </div>
          </article>)}
      </div>
    </section>;
}